import styled from 'styled-components'
import { StopType } from './TransportStopsTable.types'

export const StopsTable = styled.div`
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 6px;
  overflow: hidden;
`

export const StopRow = styled.div`
  display: grid;
  grid-template-columns: 32px 1fr auto auto;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: background 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
  }
`

export const StopIcon = styled.div<{ $type: StopType }>`
  width: 26px;
  height: 26px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;

  ${({ $type }) => {
    const configs = {
      bus: { bg: '#f59e0b15', color: '#f59e0b' },
      tram: { bg: '#3b82f615', color: '#3b82f6' },
      train: { bg: '#ef444415', color: '#ef4444' },
      metro: { bg: '#8b5cf615', color: '#8b5cf6' },
      // Multi-modal interchange — the best-connected stops, highlighted in green
      hub: { bg: '#10b98115', color: '#10b981' },
      other: { bg: '#6b728015', color: '#6b7280' },
    }
    const config = configs[$type] || configs.bus
    return `
      background: ${config.bg};
      color: ${config.color};
    `
  }}
`

export const StopName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const StopDistance = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
`
